import * as yup from 'yup';
import type { AccordionPanelProps } from 'semantic-ui-react/dist/commonjs/modules/Accordion/AccordionPanel';

import type { PageBuilderState } from '$/components/ui/Input/PageBuilder.types';
import type { InteractionInfo } from '$/components/Interactions/InteractionInfo';
import { Mentionable } from '../ui/EditableInput/types';
import { InteractionDetailsFragment, TemplateDetails } from '$/GraphQL/schema/types';
import type { StyleProps } from '../ui';

export type InteractionModalAccordionsHook = (
  _props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[];

export type InteractionModalComponentProps = {
  interaction: InteractionInfo;
  state: PageBuilderState;
  disableEdit?: boolean;
  mentions?: Mentionable[];
  save?: (values: InteractionEditableValues, keepEditing?: boolean) => void;
  setDisableEdit?: (disable: boolean) => void;
  onToggleAccordionRef?: React.MutableRefObject<
    ((values: { key: string; open?: boolean }[]) => void) | undefined
  >;
  creatingFromTemplate?: boolean;
};

export type ModalValidationRules = { [key: string]: yup.Schema<unknown> };

export enum OverlayInteractionMode {
  Edit = 'Edit',
  InCard = 'InCard',
  Live = 'Live',
}

export type InteractionAccordionPanelProps = AccordionPanelProps & {
  key: string;
};

export interface InteractionModalTitleProps {
  interaction: InteractionInfo;
  state: PageBuilderState;
  className?: string;
  disableEdit?: boolean;
  mentions?: Mentionable[];
}

export interface InteractionEditableValues {
  details: InteractionDetailsFragment & {
    playbackPosition: number;
    propertyName?: string;
    templateCategories?: string[] | null;
    templateName?: string | null;
    templateDesc?: string | null;
    templateDetails?: TemplateDetails;
    publishAsTemplate?: boolean;
    isFavorite?: boolean | null;
    enableExpireTimes?: boolean | null;
  };
}
export interface ImageDropdownItems {
  value: string;
  key: string;
  text: string;
  Image: React.FC<StyleProps>;
}
